'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Preloader = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash.omit');

var _lodash2 = _interopRequireDefault(_lodash);

var _CircleProgress = require('../CircleProgress/CircleProgress');

var _LinearProgress = require('../LinearProgress/LinearProgress');

var _ProgressHolderStyled = require('./styles/ProgressHolderStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = _extends({}, _LinearProgress.LinearProgress.propTypes, _CircleProgress.CircleProgress.propTypes, {
  /**
  * Kind of loader, used for styling
  */
  kind: _propTypes2.default.oneOf(['linear', 'circle']).isRequired,
  /**
   * Width of the Preloader
   */
  width: _propTypes2.default.string,
  /**
   * height of the Preloader
   */
  height: _propTypes2.default.string,
  /**
   * Content horizontal align
   */
  alignX: _propTypes2.default.oneOf(['left', 'center', 'right']),
  /**
   * Content vertical align
   */
  alignY: _propTypes2.default.oneOf(['top', 'bottom', 'center'])
});

var defaultProps = _extends({}, _LinearProgress.LinearProgress.defaultProps, _CircleProgress.CircleProgress.defaultProps, {
  width: '',
  height: '',
  alignX: 'center',
  alignY: 'center'
});

var preloaderProps = ['width', 'height', 'alignX', 'alignY', 'children'];

var Preloader = exports.Preloader = function Preloader(props) {
  var kind = props.kind,
      width = props.width,
      height = props.height,
      alignY = props.alignY,
      alignX = props.alignX;


  var Progress = kind === 'linear' ? _LinearProgress.LinearProgress : _CircleProgress.CircleProgress;

  return _react2.default.createElement(
    _ProgressHolderStyled.ProgressHolderStyled,
    {
      kind: kind,
      customWidth: width,
      customHeight: height,
      alignX: alignX,
      alignY: alignY
    },
    _react2.default.createElement(
      Progress,
      (0, _lodash2.default)(props, preloaderProps),
      props.children
    )
  );
};

Preloader.propTypes = propTypes;
Preloader.defaultProps = defaultProps;
Preloader.displayName = 'Preloader';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-progress/dist/Preloader/Preloader.js
// module id = 768
// module chunks = 0